// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import HorizontalForm from '../../components/HorizontalForm';
import { CURRENT_DATE, FIRST_DAY_OF_MONTH } from '../../constants';

import DataEntryTable3 from '../../components/EntryTable3';
import BackButton from '../../components/BackButton';
import { fetchForm } from '../../utils/ktcUtils';
import { useHvStateContext } from '../../context/HorizontalFormContext';
import image401 from '../../images/401.png';

const MultiEntryForm3 = () => {
  const [report, setReport] = useState([]);
  const [reportHeader, setReportHeader] = useState([]);
  const [reportFooter, setReportFooter] = useState([]);

  const params = new URLSearchParams(window.location.search);
  const queryObj = Object.fromEntries(params.entries());

  const token = getToken();
  const userId = decodeToken(token, 'id');

  const [loading, setLoading] = useState(true);
  const { route } = useParams(); // Retrieve the param from the URL

  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);

  const [executionTime, setExecutionTime] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const { hvInputsValues, setHvInputsValues } = useHvStateContext();
  const [formReportPer,setFormReportPer]=useState([]);

  useEffect(() => {
    setReport([]);
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/${route}`;

    fetchForm({
      url,
      queryObj,
      setLink,
      setInputs,
      setValues,
      setLoading,
      setFormReportPer
    });
  }, [route]);

  // console.log('values:', values);

  if (
    !loading &&
    formReportPer.length>0 &&
    formReportPer[0]?.can_view !== 1 &&
    formReportPer[0]?.can_view !== true
  ) {
    console.log("form report permission: ",formReportPer);
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `url(${image401})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "cover",
        }}
      >
      </div>
    );
  }

  return (
    <>
      <HorizontalForm
        token={token}
        link={link}
        values={values}
        inputs={inputs}
        setInputs={setInputs}
        setData={setReport}
        setReportHeader={setReportHeader}
        setReportFooter={setReportFooter}
        setPermissions={setPermissions}
        setValues={setValues}
        setExecutionTime={setExecutionTime}
      />

      {/* {report && report.length === 0 && 
        <p>No Data </p>
      }  */}
      {report && report.length > 0 && (
        <DataEntryTable3
          data={report}
          reportHeader={reportHeader}
          reportFooter={reportFooter}
          link={link}
          token={token}
          executionTime={executionTime}
          setData={setReport}
        />
      )}
    </>
  );
};

export default MultiEntryForm3;
